import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config";

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api-check-session.php`, {
      withCredentials: true, // IMPORTANT for PHP sessions
    })
    .then((res) => {
      if (res.data.session) {
        setIsAuth(true);
      } else {
        setIsAuth(false);
      }
      setLoading(false);
    })
    .catch(() => {
      setIsAuth(false);
      setLoading(false);
    });
  }, []);

  if (loading) return //<p>Loading...</p>;

  if (!isAuth) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;